"use client"

import { Link } from "react-router-dom"
import { Mail, MessageCircle, ArrowLeft, Smartphone, HelpCircle, Instagram } from "lucide-react"
import "./HomePage.css"

const SupportPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      {/* Header */}
      <header className="container mx-auto px-4 py-6 flex items-center justify-between border-b border-gray-100">
        <Link to="/" className="flex items-center gap-3 no-underline">
          <img src="/assets/icon.png" alt="whatsin? logo" className="rounded-xl w-12 h-12 shadow-lg" />
          <span className="text-2xl font-bold">
            <span style={{ color: "#ff9f43" }}>whatsin</span>
            <span style={{ color: "#ff9f43" }}>?</span>
          </span>
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-3 text-white px-6 py-3 rounded-lg font-semibold transition-all hover:shadow-lg hover:scale-105 no-underline"
          style={{ backgroundColor: "#ff9f43" }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#e8873a")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#ff9f43")}
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="hidden sm:inline">Ana Sayfa</span>
          <span className="sm:hidden">Geri</span>
        </Link>
      </header>

      {/* Support Content */}
      <section className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Hero Section */}
          <div className="text-center space-y-8 mb-20">
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium shadow-sm"
              style={{ backgroundColor: "#fff7ed", color: "#ff9f43" }}
            >
              <MessageCircle className="w-4 h-4" />Destek & İletişim
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-800">
              Size Nasıl <span style={{ color: "#ff9f43" }}>Yardımcı</span> Olabiliriz?
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Herhangi bir sorunuz varsa ya da yardıma ihtiyacınız olursa bizimle iletişime geçebilirsiniz! 🌟
            </p>
          </div>

          {/* Contact Section */}
          <div className="bg-white p-12 rounded-2xl shadow-xl mb-20 border-0">
            <div className="text-center space-y-8">
              <div
                className="w-24 h-24 mx-auto rounded-2xl flex items-center justify-center shadow-lg"
                style={{ backgroundColor: "#fff7ed" }}
              >
                <Mail className="w-12 h-12" style={{ color: "#ff9f43" }} />
              </div>
              <div className="space-y-6">
                <h2 className="text-3xl font-bold text-gray-700">Bizimle İletişime Geçin</h2>
                <p className="text-lg text-gray-600">Sorularınız için bize e-posta gönderebilirsiniz</p>
                <a
                  href="mailto:ebruipekaktukmak@gmail.com"
                  className="inline-flex items-center gap-3 text-white px-8 py-4 text-lg font-semibold rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105 no-underline"
                  style={{ backgroundColor: "#ff9f43" }}
                  onMouseEnter={(e) => (e.target.style.backgroundColor = "#e8873a")}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = "#ff9f43")}
                >
                  <Mail className="w-6 h-6" />
                  E-posta Gönder
                </a>
                <div className="text-gray-500 mt-4">ebruipekaktukmak@gmail.com</div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="space-y-12">
            <div className="text-center space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium shadow-sm bg-purple-50 text-purple-700">
                <HelpCircle className="w-4 h-4" />Sıkça Sorulan Sorular
              </div>
              <h2 className="text-4xl font-bold text-gray-800">
                En Çok <span style={{ color: "#ff9f43" }}>Merak Edilenler</span>
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Kullanıcılarımızın en sık sorduğu soruları derledik. Aradığınızı bulamazsanız bize yazın!
              </p>
            </div>

            {/* FAQ Items */}
            <div className="space-y-6">
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
                <div className="flex items-start gap-6">
                  <div
                    className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
                    style={{ backgroundColor: "#fff7ed" }}
                  >
                    <Smartphone className="w-8 h-8" style={{ color: "#ff9f43" }} />
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-xl font-bold text-gray-700">📱 Uygulamayı nasıl kullanabilirim?</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Ürünleri arayarak ya da barkodlarını okutarak içeriklerini inceleyebilir ve sizin için uygun olup
                      olmadığını öğrenebilirsiniz. Ayrıca içerik listesini fotoğraflayarak da analiz yapabilirsiniz!
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-400 to-orange-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                    <HelpCircle className="w-8 h-8 text-white" />
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-xl font-bold text-gray-700">🔍 Barkod okuma çalışmıyor, ne yapmalıyım?</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Kamera izinlerinin açık olduğundan emin olun. Sorun devam ederse manuel arama yapabilir veya
                      içerik listesini fotoğraflayabilirsiniz.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-pink-400 to-pink-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                    <MessageCircle className="w-8 h-8 text-white" />
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-xl font-bold text-gray-700">📩 Geri bildirim gönderebilir miyim?</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Elbette! Görüş ve önerilerinizi{" "}
                      <a
                        href="mailto:ebruipekaktukmak@gmail.com"
                        className="font-semibold hover:underline transition-colors no-underline"
                        style={{ color: "#ff9f43" }}
                      >
                        ebruipekaktukmak@gmail.com
                      </a>{" "}
                      adresine iletebilirsiniz. Geri bildirimleriniz bizim için çok değerli!
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-400 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                    <HelpCircle className="w-8 h-8 text-white" />
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-xl font-bold text-gray-700">🔒 Verilerim güvende mi?</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Evet! Kişisel verileriniz tamamen güvende. Sadece ürün analizleri için gerekli bilgileri
                      kullanıyoruz ve hiçbir kişisel veriyi üçüncü taraflarla paylaşmıyoruz.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-green-400 to-green-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                    <MessageCircle className="w-8 h-8 text-white" />
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-xl font-bold text-gray-700">✨ Uygulama ücretsiz mi?</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Evet! whatsin? uygulaması tamamen ücretsiz. Tüm özellikler herkes için açık ve hiçbir ücret talep
                      etmiyoruz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Still Need Help Section */}
          <div
            className="text-center mt-20 p-12 rounded-2xl"
            style={{ background: "linear-gradient(135deg, #ff9f43 0%, #f7931e 50%, #e8873a 100%)" }}
          >
            <div className="space-y-8 text-white">
              <div className="w-24 h-24 mx-auto bg-white/20 rounded-2xl flex items-center justify-center">
                <MessageCircle className="w-12 h-12" />
              </div>
              <h2 className="text-4xl font-bold">Hala Sorunuz mu Var?</h2>
              <p className="text-xl opacity-90 max-w-2xl mx-auto">
                Yukarıdaki sorular arasında aradığınızı bulamadınız mı? Bize yazın, size yardımcı olmaktan mutluluk
                duyarız! 💌
              </p>
              <a
                href="mailto:ebruipekaktukmak@gmail.com"
                className="inline-flex items-center gap-3 bg-white hover:bg-gray-100 px-8 py-4 text-lg font-semibold rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105 no-underline"
                style={{ color: "#ff9f43" }}
              >
                <Mail className="w-6 h-6" />
                Bize Yazın
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 gap-8 items-center">
            <div className="space-y-4 text-center sm:text-left">
              <div className="flex items-center gap-3 justify-center sm:justify-start">
                <img src="/assets/icon.png" alt="whatsin? logo" className="rounded-lg w-10 h-10" />
                <span className="text-2xl font-bold text-white">
                  whatsin
                </span>
              </div>
              <p className="text-gray-400">Güzellik dünyasında akıllı rehberin! 💄✨</p>
            </div>
            <div className="flex flex-wrap gap-4 justify-center sm:justify-end items-center">
              <a
                href="https://www.instagram.com/whatsin_app/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors no-underline flex items-center gap-2"
              >
                <Instagram className="w-5 h-5" />
                <span className="hidden sm:inline">Instagram</span>
              </a>
              <Link to="/" className="text-gray-400 hover:text-white transition-colors no-underline">
                Ana Sayfa
              </Link>
              <Link to="/legal" className="text-gray-400 hover:text-white transition-colors no-underline">
                Kullanım Koşulları
              </Link>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>&copy; 2026 whatsin? Tüm hakları saklıdır. Made with 💖 for healthy living.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default SupportPage
